import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListPosition = createAsyncThunk('positon-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}position/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createPosition = createAsyncThunk('positon-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}position/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editPosition = createAsyncThunk('positon-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}position/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const togglePosition = createAsyncThunk('positon-toggle', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}position/toggle/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewPosition = createAsyncThunk('positon-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}position/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type PositionState = {
  errors: any
}

const initialState: PositionState = {
  errors: '',
}

export const positionSlice = createSlice({
  name: 'position',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createPosition.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = positionSlice.actions
export default positionSlice.reducer
